import { Icon } from '@chakra-ui/react';
import { BsArrowRight } from 'react-icons/bs';

const ArrowIcon = (props) => {
  return (
    <Icon as={BsArrowRight} verticalAlign='middle' {...props} />
  );
}

export default ArrowIcon;